export enum UserRole {
    HRD = "hrd",
    DEPARTMENT_MANAGER = "department_manager",
    RECRUITER = "recruiter",
    ACCOUNT_MANAGER = "account_manager",
    DELIVERY_MANAGER = "delivery_manager",
    ADMIN = "admin",
}

export interface AuthLoginRequest {
    login: string;
    password: string;
}
export interface AuthLoginResponse {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    department_id: number | null;
    channel_id: number | null;
    access_token: string;
    access_token_expired_at: number;
    refresh_token: string;
    refresh_token_expired_at: number;
    role: UserRole;
}

